import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["button", "field"];

  connect() {
    this.toggleButton();
  }

  fieldChanged() {
    this.toggleButton();
  }

  toggleButton() {
    this.buttonTarget.disabled = this.fieldTargets.some((field) => field.value.trim() === "");
  }
}
